import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import {
  Client,
  MeterMakeDataOut,
  PageInfo,
  RegionDetailsDataOut,
  RegionGetAllDataIn,
  SortingType,
} from '../../../../api/api-reference';
import { PermissionsEnum } from '../../../../api/api-reference';
import { AuthService } from '../../../../services/auth.service';
import { ClipboardService } from '../../../../services/clipboard.service';
import { SearchComponent } from '../../../core/components/search/search.component';
import { SortComponent } from '../../../core/components/sort/sort.component';
import { PaginationComponent } from '../../../core/components/pagination/pagination.component';
import { RegionSetupComponent } from './region-setup/region-setup.component';
import { ConfirmDialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-region-management',
  standalone: true,
  imports: [
    CommonModule,
    SearchComponent,
    SortComponent,
    TranslateModule,
    PaginationComponent,
    RegionSetupComponent,
    ConfirmDialogComponent,
  ],
  templateUrl: './region-management.component.html',
  styleUrl: './region-management.component.scss',
})
export class RegionManagementComponent {
  data: RegionDetailsDataOut[] | undefined = [];
  public pageSize: number = 10;
  public pageNumber: number = 1;
  public lastPageSize: number = 1;
  public currentPage: number = 1;
  isModalOpen = false;
  isAddClicked = false;
  selectedRowId: string | null = null;
  public numberOfRegions: number = 0;
  public PermissionsEnum = PermissionsEnum;

  requestData = new RegionGetAllDataIn({
    pageInfo: new PageInfo({ pageSize: this.pageSize, page: this.pageNumber }),
    search: undefined,
    sorting: SortingType.Descending,
  });

  constructor(
    private client: Client,
    private toastr: ToastrService,
    public authService: AuthService,
    public clipboardService: ClipboardService,
  ) {
    this.reloadTable(1);
  }

  toggleModal(reload?: boolean) {
    this.selectedRowId = null;
    this.isAddClicked = !this.isAddClicked;
    if (reload) {
      this.reloadTable();
    }
  }

  onSortOption(selectedSort?: SortingType) {
    if (selectedSort) this.requestData.sorting = selectedSort;
    this.reloadTable();
  }

  handleRowClick(row: MeterMakeDataOut) {
    this.selectedRowId = row.id!;
    if (!this.isModalOpen) {
      this.isAddClicked = true;
    }
  }

  reloadTable(page?: number) {
    this.pageNumber = page || 0;
    if (page) this.requestData!.pageInfo!.page = this.pageNumber;

    this.client.regionQuery(this.requestData).subscribe({
      next: (response) => {
        this.data = response.data;
        this.numberOfRegions = response.count || 0;
        this.lastPageSize = Math.ceil(this.numberOfRegions / this.pageSize);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
    this.selectedRowId = null;
  }

  searchChange(searchText: string) {
    this.requestData.search = searchText;
    this.reloadTable(1);
  }

  handleDelete() {
    this.isModalOpen = true;
  }

  confirmDelete(row: string) {
    this.client.deleteRegion(row).subscribe({
      next: (response) => {
        this.toastr.success(response);
        this.reloadTable(this.currentPage);
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
    this.isModalOpen = false;
    this.selectedRowId = null;
    this.isAddClicked = false;
  }

  cancelDelete() {
    this.isModalOpen = false;
    this.selectedRowId = null;
  }
  pageChange(value: number) {
    this.currentPage = value;
    this.reloadTable(this.currentPage);
  }
}
